import { render } from "./AppSectionFooterMenu.vue?vue&type=template&id=cfba4f3a&scoped=true&ts=true&lang=pug"
import script from "./AppSectionFooterMenu.vue?vue&type=script&lang=ts"
export * from "./AppSectionFooterMenu.vue?vue&type=script&lang=ts"

import "./AppSectionFooterMenu.vue?vue&type=style&index=0&id=cfba4f3a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfba4f3a"]])

export default __exports__